import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { Flex } from '../../components/Flex'
import { Text } from '../../components/Text'
import { Button } from '../../components/Button'
import { ProfileManagementActions } from '../../redux/account/profile-management'

const ViewBorder = styled(Flex)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
  align-items: center;
  align-content: center;
  text-align: center;
  height: 350px;
  color: ${({ theme }) => theme.colors.textPrimary};
`

const CenteredText = styled(Text)`
  text-align: center;
  width: 80%;
  margin-bottom: 20px;
`

export const ProfileManagementEmptyView = () => {
  const { t } = useTranslation(['account'])
  const tpm = (key: string) => t(`account:ProfileManagement.${key}`)
  const dispatch = useDispatch()
  const handleGenerateInvitationLink = () => {
    dispatch(ProfileManagementActions.openDialogToInvitationLinkGeneration())
  }
  return (
    <>
      <ViewBorder>
        <Flex
          style={{
            justifyContent: 'center',
            width: '100%',
            flexGrow: 1,
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <CenteredText>{tpm('EmptyProfilesView_DescriptiveText')}</CenteredText>
          <CenteredText>{tpm('EmptyProfilesView_EmptyProfilesText')}</CenteredText>
          <Button onClick={handleGenerateInvitationLink} variant="primary" size="middle">
            {tpm('EmptyProfilesView_CTAButton')}
          </Button>
        </Flex>
      </ViewBorder>
    </>
  )
}

export default ProfileManagementEmptyView
